import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  wrapper: css`
    width: 100%;
    max-width: 812px;
  `,
  embedBorder: css`
    border: 1px solid ${colors.silver};
  `,
  embedFlyerBorder: css`
    border-left: 1px solid ${colors.silver};
    border-right: 1px solid ${colors.silver};
  `,
  profileLink: css`
    color: ${colors.jungle};
    text-decoration: none;
    cursor: pointer;
  `,
  flyerInfoContainer: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    @media only screen and (min-width: 992px) {
      align-items: center;
    }
  `,
  skeleton: css`
    padding: 0px 16px 8px 16px;
  `,
  providedBy: css`
    padding-top: 12px;
    border-top: 3px solid ${colors.silver};
  `,
  flex: css`
    display: flex;
  `,
  flyerIdContainer: css`
    display: flex;
    justify-content: center;
    border-top: 3px solid ${colors.silver};
    padding: 24px;
  `,
};

export default styles;
